// Keep in sync with lang-js/apps/website/shared/OwnershipAreas.ts
// Derived from: https://www.notion.so/outschool/0f57b8ae7ea3459b9963e0b9ae63b049
//          and: https://www.notion.so/outschool/b4d911c386d04200889f83c77b988dee
export enum Component {
  // N.B. that there is no "unknown" or "misc" component.
  // You can add such a catch-all to this enum,
  // but we would encourage you to consider adding
  // a new product area instead of such a concept.
  BackpackStorybook = "Backpack Storybook",
  BuyerOrgs = "Buyer Orgs",
  CategoryPages = "Category Pages",
  // TODO: Add to https://www.notion.so/outschool/0f57b8ae7ea3459b9963e0b9ae63b049
  //         and: https://www.notion.so/outschool/b4d911c386d04200889f83c77b988dee
  ChatGPTPlugin = "ChatGPT Plugin Service",
  Classroom = "Classroom",
  ComponentLibrary = "Component Library",
  ContentModeration = "Content Moderation",
  DataDeletion = "Data Deletion",
  EmailNotifications = "Email Notifications",
  EnrollmentsParent = "Enrollments for Parents",
  EnrollmentsTeacher = "Enrollments for Teachers",
  ExperimentationFramework = "Experimentation Framework",
  GoogleSearchConsole = "Google Search Console",
  Infra = "Infra",
  International = "International",
  IpLookupService = "IP Lookup Service",
  LearnerDataPipeline = "Learner Data Pipeline",
  LearnerMode = "Learner Mode / Learner UX (Learner privacy, learner accounts)",
  LearnerApp = "Learner App",
  Marketing = "Marketing",
  Messaging = "Messaging",
  Notifications = "Notifications",
  Orders = "Orders",
  ParentAdminTools = "Parent CX and Admin Tools",
  ParentEmailNotifications = "Parent Email Notifications",
  Payouts = "Payouts",
  Recommendations = "Recommendations",
  Recordings = "Recordings",
  ReferralProgram = "Referral Program",
  SEOTaxonomy = "SEO Taxonomy",
  Search = "Search",
  SearchRanking = "SearchRanking",
  ServerRenderedWebsite = "Server Rendered Website",
  Sitemap = "Sitemap",
  TeacherAdminTools = "Teacher CX and Admin Tools",
  TeacherTools = "Teacher Tools",
  Tracking = "Tracking",
  TrustAndSafety = "Trust and Safety",
  UserAccountManagement = "User Account Management",
  Website = "Website",
  Zoom = "Zoom"
}

export enum EngineeringTeams {
  AllTeams = "AllTeams",
  Discovery = "Discovery", // pod-discovery-alerts
  Infra = "Infra",
  NewFamilies = "NewFamilies", // pod-new-families-alerts
  Platform = "Platform", // pod-platform-alerts
  Supply = "Supply" //pod-supply-alerts
}

export const OwnershipAreas: Record<Component, EngineeringTeams> = {
  [Component.Website]: EngineeringTeams.AllTeams,
  [Component.BackpackStorybook]: EngineeringTeams.Platform,
  [Component.BuyerOrgs]: EngineeringTeams.Supply,
  [Component.CategoryPages]: EngineeringTeams.NewFamilies,
  [Component.ChatGPTPlugin]: EngineeringTeams.Infra,
  [Component.Classroom]: EngineeringTeams.Supply,
  [Component.ComponentLibrary]: EngineeringTeams.Platform,
  [Component.ContentModeration]: EngineeringTeams.Supply,
  [Component.DataDeletion]: EngineeringTeams.Infra,
  [Component.EmailNotifications]: EngineeringTeams.NewFamilies,
  [Component.EnrollmentsParent]: EngineeringTeams.Supply,
  [Component.EnrollmentsTeacher]: EngineeringTeams.Supply,
  [Component.ExperimentationFramework]: EngineeringTeams.Infra,
  [Component.GoogleSearchConsole]: EngineeringTeams.NewFamilies,
  [Component.Infra]: EngineeringTeams.Infra,
  [Component.International]: EngineeringTeams.Platform,
  [Component.IpLookupService]: EngineeringTeams.Platform,
  [Component.LearnerDataPipeline]: EngineeringTeams.Infra,
  [Component.LearnerMode]: EngineeringTeams.Discovery,
  [Component.LearnerApp]: EngineeringTeams.Platform,
  [Component.Marketing]: EngineeringTeams.NewFamilies,
  [Component.Messaging]: EngineeringTeams.Discovery,
  [Component.Notifications]: EngineeringTeams.Platform,
  [Component.Orders]: EngineeringTeams.Supply,
  [Component.ParentAdminTools]: EngineeringTeams.Discovery,
  [Component.ParentEmailNotifications]: EngineeringTeams.NewFamilies,
  [Component.Payouts]: EngineeringTeams.Supply,
  [Component.Recommendations]: EngineeringTeams.Discovery,
  [Component.Recordings]: EngineeringTeams.Platform,
  [Component.ReferralProgram]: EngineeringTeams.NewFamilies,
  [Component.SEOTaxonomy]: EngineeringTeams.NewFamilies,
  [Component.SearchRanking]: EngineeringTeams.Discovery,
  [Component.Search]: EngineeringTeams.Discovery,
  [Component.ServerRenderedWebsite]: EngineeringTeams.NewFamilies,
  [Component.Sitemap]: EngineeringTeams.NewFamilies,
  [Component.TeacherAdminTools]: EngineeringTeams.Supply,
  [Component.TeacherTools]: EngineeringTeams.Supply,
  [Component.Tracking]: EngineeringTeams.AllTeams,
  [Component.TrustAndSafety]: EngineeringTeams.Platform,
  [Component.UserAccountManagement]: EngineeringTeams.Platform,
  [Component.Zoom]: EngineeringTeams.Platform
};
